var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.name + "__wrap"),domProps:{"textContent":_vm._s(_vm.$t('module_dynamic_destination_switch_tips_introduce'))}})}
var staticRenderFns = []

export { render, staticRenderFns }